import * as wheelDownDirective from './wheel-down.directive';

export default angular.module('gazelle.components.mouse.wheelDown', [
])
  .directive(wheelDownDirective.name, wheelDownDirective.default)
  .name;
